import React from "react";

const ArrowNext = () => (
	<svg width="20" height="21" viewBox="0 0 20 21"  xmlns="http://www.w3.org/2000/svg">
		<path d="M15.2199 13.9496L18.1886 10.9809C18.3816 10.7879 18.3816 10.4742 18.1886 10.2812L15.2199 7.31253C15.0774 7.17003 14.8656 7.12748 14.6806 7.20466C14.4955 7.28086 14.3748 7.46195 14.3748 7.66185V9.97953L2.99479 9.97953C2.72166 9.97953 2.5 10.2012 2.5 10.4743L2.5 10.7868C2.5 11.0599 2.72166 11.2816 2.99479 11.2816L14.3748 11.2816V13.5993C14.3748 13.7991 14.4955 13.9802 14.6806 14.0564C14.8656 14.1326 15.0774 14.0901 15.2199 13.9496Z" />
	</svg>
);

export default ArrowNext;